import { render, staticRenderFns } from "./ViAdminHome.vue?vue&type=template&id=616aed5a"
import script from "./ViAdminHome.vue?vue&type=script&lang=js"
export * from "./ViAdminHome.vue?vue&type=script&lang=js"
import style0 from "./ViAdminHome.vue?vue&type=style&index=0&id=616aed5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports